import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AccountType, CampaignType } from "@front/m19-api-client";
import { AccountSelectionService, SbStrategyService } from "@front/m19-services";
import { BoardType, LayoutSelectorService } from "@m19-board/layout-selector.service";
import { of, startWith, switchMap } from "rxjs";
import { StrategyListComponent } from "@m19-board/strategies/strategy-list/strategy-list.component";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-sb-manager",
  templateUrl: "./sb-manager.component.html",
  imports: [StrategyListComponent, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SbManagerComponent implements OnInit {
  private sbStrategyService = inject(SbStrategyService);
  private accountSelectionService = inject(AccountSelectionService);
  private layoutSelectorService = inject(LayoutSelectorService);

  readonly hasBrand = toSignal(
    this.accountSelectionService.singleAccountMarketplaceSelection$.pipe(
      switchMap((am) =>
        am.accountType == AccountType.VENDOR
          ? of(true)
          : this.sbStrategyService.hasBrands(am.accountId, am.marketplace).pipe(startWith(undefined)),
      ),
    ),
    { initialValue: true },
  );
  m19BoardType = false;
  readonly CampaignType = CampaignType;

  ngOnInit() {
    this.m19BoardType = this.layoutSelectorService.getBoardType() == BoardType.M19;
  }
}
